import React from 'react'
import { isMobile } from 'react-device-detect'

import { CompactTable } from '@table-library/react-table-library/compact'
import { useTheme } from '@table-library/react-table-library/theme'

const PendingInvoicesTable = ({ data = [], columns = [] }) => {

  // needs id as a prop
  data = data.map(v => { v.id = v._id; return v })

  const tableData = {
    nodes: data,
  }

  const tableTheme = useTheme(
    [
      // getTheme(),
      {
        Table: `
        --data-table-library_grid-template-columns: 
          minmax(11rem, 1fr) // Renewal Date
          minmax(21rem, 1fr) // Plan
          minmax(21rem, 1fr) // Failure Reason
          minmax(8rem, 1fr); // Invoices

          grid-template-rows: max-content;

          height: 100%;
        `,
        HeaderCell: `
          height: fit-content;
          border-top: 1px solid #dee2e6;
          border-left: 0.5px solid #dee2e6;
          :last-of-type {
            border-right: 1px solid #dee2e6;
          }
          color: #4c4c4c !important;
      `,
        Row: `
          font-size:15px;
          .td {
            border-bottom: 1px solid #dee2e6;
            border-left: 1px solid #dee2e6;
          }
      `,
        BaseCell: `
          .td {
            border-left: 1px solid #dee2e6;
          }
      `,
        Cell: `
          >div {
            text-wrap:auto;
          } 
          :last-of-type {
            border-right: 1px solid #dee2e6;
          }
      `
      }
    ]
  )

  return (
    <div className='pending-invoices-list-table'>
      <CompactTable
        columns={columns}
        data={tableData}
        layout={{
          fixedHeader: true,
          horizontalScroll: !isMobile,
          custom: true
        }}
        theme={tableTheme}
      />
    </div>
  )
}

export default PendingInvoicesTable